'use client'

import { useState } from 'react'

import Select from 'react-select'

import cn from 'clsx'

import { type List as ListType } from '../../../../../apps/benmax/src/types/sanity.types'

import Item from './Item'

import s from './List.module.sass'

function List({ title, includeYearFilter, items }: ListType) {
    const [selectedYear, setSelectedYear] = useState<number | null>(null)

    const _items = items
        ?.filter((item) => {
            if (selectedYear) {
                return item.year === selectedYear
            }
            return true
        })
        .sort((a: any, b: any) => b.year - a.year)

    const _years = items?.map((item) => item.year)
    const uniqueYears = Array.from(new Set(_years)).sort((a: any, b: any) => b - a)

    return (
        <section className={s.List}>
            <div className={cn(s.Cont, 'container')}>
                {(title || includeYearFilter) && (
                    <div className={s.Intro}>
                        {title && <h4 dangerouslySetInnerHTML={{ __html: title }} />}
                        {includeYearFilter && (
                            <div className={s.YearFilter}>
                                <Select
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    options={[
                                        { value: null, label: 'Filter by year' },
                                        ...uniqueYears?.map((year) => ({
                                            value: year,
                                            label: year,
                                        })),
                                    ]}
                                    onChange={(option) => {
                                        setSelectedYear(option?.value ?? null)
                                    }}
                                    placeholder="Filter by year"
                                    isSearchable={false}
                                />
                            </div>
                        )}
                    </div>
                )}
                {_items?.map((item, index) => <Item item={item} key={index} />)}
            </div>
        </section>
    )
}

export default List
